// Module
var code = "<h2 id=\"repayment-plans\">Repayment Plans</h2> <p>Choose a plan that fits your financial situation.</p> ";
// Exports
export default code;